import {Component, ViewChild, AfterViewInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {AppService} from '@api';
import {SistemaService} from '@servicios/Sistema.Service';

import {AlertaEnum, DialogoEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {MensajeService} from '@mensaje/Mensaje.Service';
import {RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';

import {FiltrosComponent} from '@componentes/Filtros/Filtros.component';
import {FiltroModel} from '@componentes/Filtros/Filtro.model';
import {TipoFiltroEnum} from '@componentes/Filtros/Filtros.enum';

import {EscalaEvaluacion} from '@modelo/catalogo/EscalaEvaluacion.model';
import {EscalaEvaluacionValor} from '@modelo/catalogo/EscalaEvaluacionValor.model';


@Component(
    {
        selector: 'escalaevaluacion',
        templateUrl: './escalaevaluacion.template.html',
        styleUrls: ['./escalaevaluacion.component.scss']
    })

export class EscalaevaluacionComponent implements AfterViewInit {
    dataTable!: Array<any>;
    dataTable2!: Array<any>;

    public entidad: EscalaEvaluacion;
    public entidad2: EscalaEvaluacionValor;
    public idTemp: any;

    public abierto!: boolean;
    public abierto2!: boolean;
    public animacion!: string;
    public animacion2!: string;
    public errorActivo!: boolean;
    public errorActivo2!: boolean;

    @ViewChild(FiltrosComponent) filtrosComponent!: FiltrosComponent;
    filtrosDisplay: Array<FiltroModel> = [];
    uriApi: string

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService) {
        this.entidad = new EscalaEvaluacion();
        this.entidad2 = new EscalaEvaluacionValor();
        this.dataTable2 = [];
        this.uriApi = "configuracion/escalaevaluacion/buscar";
        //this.GenerarFiltros()
    }


    ngAfterViewInit() {
        this.appService.Get("configuracion/escalaevaluacion/filtros").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.filtrosDisplay  = res.data;
                this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
            }
        });
        
    }

    GenerarFiltros() {
        let filtrosDisplay: Array<FiltroModel> = [];
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'Nombre',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'nombre'
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Activo',
                    DisplayValor: 'nombre',
                    ValorName: 'valor',
                    Opciones: [{nombre: "Sí", valor: true}, {nombre: "No", valor: false}],
                    Propiedad: "activo",
                    Obligatorio: false,
                    Buscar: false
                })
        );
        this.filtrosDisplay = filtrosDisplay;
    }

    SetDatos(data: any) {
        this.dataTable = data;
    }

    Editar(e: EscalaEvaluacion) {
        this.entidad = new EscalaEvaluacion(e);
        this.Modal();
    }

    Modal() {
        this.animacion = this.sistemaService.animacionAbirModal;
        this.abierto = true;
        this.errorActivo = false;
        this.getValores();
    }

    CerrarModal() {
        this.entidad = new EscalaEvaluacion();
        this.animacion = this.sistemaService.animacionCerrarModal;
        this.dataTable2 = [];

        setTimeout(() => {
            this.abierto = false;
        }, 310);
    }

    Guardar() {
        this.errorActivo = true;

        if (!this.entidad.nombre || !this.entidad.nombre.trim()) {
            return this.mensajeService.Alerta(AlertaEnum.Warning, "Ingrese un nombre");
        }
        if (this.dataTable2.length == 0) {
            return this.mensajeService.Alerta(AlertaEnum.Warning, "Ingrese mínimo una opción");
        }
        
        let data = new EscalaEvaluacion(this.entidad)
        if (!this.entidad.escalaevaluacionid) {
            data.opciones = this.dataTable2;
        }
        
        this.appService.Post("configuracion/escalaevaluacion", data).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                this.CerrarModal();
                this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
            }
        })
    }

    Eliminar(e: EscalaEvaluacion) {
        let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar el registro? <br> Esta acción no se podra deshacer.', opciones).then(res => {
            if (res == 1) {
                this.appService.Delete("configuracion/escalaevaluacion/" + e.escalaevaluacionid).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                        this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
                    }
                })
            }
        })
    }



    getValores() {
        if (!this.entidad.escalaevaluacionid) {
            return;
        }
        this.appService.Get("configuracion/escalaevaluacion/valor/" + this.entidad.escalaevaluacionid).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.dataTable2 = res.data
            }
        });
    }

    Editar2(e: any) {
        this.entidad2 = new EscalaEvaluacionValor(e.data);
        
        this.idTemp = this.entidad2.escalaevaluacionid ? null : e.rowIndex;

        this.Modal2();
    }

    Modal2() {
        this.animacion2 = this.sistemaService.animacionAbirModal;
        this.abierto2 = true;
        this.errorActivo2 = false;
    }

    CerrarModal2() {
        this.entidad2 = new EscalaEvaluacionValor();
        this.animacion2 = this.sistemaService.animacionCerrarModal;

        setTimeout(() => {
            this.abierto2 = false;
        }, 310);
    }

    Guardar2() {
        this.errorActivo2 = true;

        if (!this.entidad2.nombre || !this.entidad2.nombre.trim()) {
            return this.mensajeService.Alerta(AlertaEnum.Warning, "Ingrese una opción");
        }
        if (!this.entidad2.descripcion || !this.entidad2.descripcion.trim()) {
            return this.mensajeService.Alerta(AlertaEnum.Warning, "Ingrese una descripción");
        }
        if (!this.entidad2.color || !this.entidad2.color.trim()) {
            return this.mensajeService.Alerta(AlertaEnum.Warning, "Ingrese un color");
        }
        
        if (!this.entidad.escalaevaluacionid) {
            if (this.idTemp == null){
                this.dataTable2.push(this.entidad2);
            }else{
                this.dataTable2[this.idTemp] = this.entidad2;
                this.idTemp = null;
            }
            
            this.CerrarModal2();
            return;
        }

        let data = new EscalaEvaluacionValor(this.entidad2)
        this.appService.Post("configuracion/escalaevaluacion/valor/" + this.entidad.escalaevaluacionid, data).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                this.CerrarModal2();
                this.getValores();
            }
        })
    }

    Eliminar2(e: any) {
        let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar el registro? <br> Esta acción no se podra deshacer.', opciones).then(res => {
            if (res == 1) {
                if (!this.entidad.escalaevaluacionid) {
                    this.dataTable2.splice(e.rowIndex, 1);
                    return;
                }

                this.appService.Delete("configuracion/escalaevaluacion/valor/" + e.data.escalaevaluacionvalorid).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                        this.getValores();
                    }
                })
            }
        })
    }
}
